/**
 * Main JavaScript file for common functionality
 * Enhanced with advanced theme and layout management
 */

; (function () {
    'use strict'

    // Set assets path and layout path variables
    window.assetsPath = document.documentElement.getAttribute('data-assets-path')
    window.layoutPath = ''
    window.commonAssetsPath = ''

    const root = document.documentElement
    const localStorageKey = `dashboard-default-theme`
    const localAppThemeStorageKey = 'dialerai-application-theme'

    // Function to get current system theme preference
    const getSystemPreference = () => window.matchMedia('(prefers-color-scheme: dark)').matches
    const getApplicationTheme = () => {
        return window.localStorage.getItem(localAppThemeStorageKey) || 'light'
    }

    // Function to resolve theme based on selected theme and layout configuration
    const resolveTheme = theme => {
        // Use more robust access pattern
        if (theme === 'system') {
            // Final fallback if no layout config exists
            return getSystemPreference() ? 'dark' : getApplicationTheme()
        }

        return theme
    }

    // Apply selected theme and update dropdown UI
    const applyTheme = themeValue => {
        const finalTheme = resolveTheme(themeValue)
        root.setAttribute('data-theme', finalTheme)
        window.localStorage.setItem(localStorageKey, themeValue)

        // Update dropdown active state
        document.querySelectorAll('[data-theme-value]').forEach(btn => {
            const isActive = btn.getAttribute('data-theme-value') === themeValue
            btn.classList.toggle('dropdown-active', isActive)
            btn.setAttribute('aria-pressed', isActive)
        })

        // Theme Controller
        $('.theme-controller').each(function () {
            const ariaLabel = $(this).attr('aria-label');
            if (ariaLabel === 'light/dark mode') {
                $(this).val(themeValue);
            }
        })

        // Toggle icon visibility
        const activeBtn = document.querySelector(`[data-theme-value="${themeValue}"]`)
        const iconName = activeBtn?.getAttribute('data-icon') || 'sun-moon'
        document.querySelectorAll('.theme-icon').forEach(iconEl => {
            if (iconEl.classList.contains(`icon-[tabler--${iconName}]`)) {
                iconEl.classList.remove('hidden')
            } else {
                iconEl.classList.add('hidden')
            }
        })

        // Dispatch custom event for theme change
        window.dispatchEvent(new window.CustomEvent('themeChanged', {
            detail: { theme: themeValue, resolvedTheme: finalTheme }
        }))
    }

    // Get saved theme or default to 'system'
    const savedTheme = window.localStorage.getItem(localStorageKey) || 'system'
    applyTheme(savedTheme)

    // Bind dropdown click handlers
    document.querySelectorAll('[data-theme-value]').forEach(btn => {
        btn.addEventListener('click', () => {
            const selectedTheme = btn.getAttribute('data-theme-value')
            applyTheme(selectedTheme)
        })
    })

    // Listen to system theme changes (live update if in 'system' mode)
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
        const currentTheme = window.localStorage.getItem(localStorageKey)
        if (currentTheme === 'system') {
            // Force recalculation of the system theme fallback
            applyTheme('system')
        }
    })

    // Theme Controller
    $('.theme-controller').on('click', function () {
        let themeValue = $(this).val();
        // get aria-label
        const ariaLabel = $(this).attr('aria-label');
        if (ariaLabel === 'light/dark mode') {
            themeValue = themeValue === 'dark' ? getApplicationTheme() : 'dark';
            $(this).val(themeValue);
            document.documentElement.setAttribute('data-theme-color', themeValue);
            applyTheme(themeValue);
        } else {
            applyTheme(themeValue);
        }
    });
    window.themeManager = {
        applyTheme,
        resolveTheme,
        get theme() {
            return window.localStorage.getItem(localStorageKey) || 'light'
        }
    }
})()
